export const DESCRIPTION_MAX_CHARACTERS = 4000;
export const DESCRIPTION_MIN_CHARACTERS = 30;
export const REVIEW_VIOLATION_TERMS: readonly string[] = [
  'followers',
  'follows',
  'likes',
  'retweet',
  'retweets',
  'review',
  'reviews',
  'share',
  'shares',
  'tweet',
  'tweets',
];
export const REVIEW_VIOLATION_SITES: readonly string[] = [
  'amazon',
  'city search',
  'citysearch',
  'ebay',
  'expedia',
  'facebook',
  'fb',
  'google',
  'ig',
  'instagram',
  'trip advisor',
  'tripadvisor',
  'twitter',
  'yelp',
];
